export default __webpack_public_path__ + "static/media/sortIcon.85e4ba3b.svg";